export default "__VITE_ASSET__1096576f__"